import { useState } from "react"
import { Popup, Button } from 'semantic-ui-react'

const AlertsPopup = ({ callback }) => {

    const [opened, setOpened] = useState(false)

    return <Popup
        trigger={<Button size="tiny" color="yellow" onClick={() => setOpened(true)}>Reset</Button>}
        on="click"
        open={opened}
        onClose={() => setOpened(false)}
    >
        <Popup.Content>
            <div>Are you sure?</div>
            <div>
                <Button size="tiny" color="green" onClick={() => {callback(); setOpened(false)}}>Yes</Button>
                <Button size="tiny" color="red" onClick={() => setOpened(false)}>No</Button>
            </div>
             
        </Popup.Content>
    </Popup>

}

export default AlertsPopup